export default "__VITE_ASSET__BFyq$JyB__"